import { LoaderFunction, useLoaderData } from "react-router-dom";
import { subscribe } from "../../../common/api/decimal/methods/subscribe.ts";

export const subscribeLoader: LoaderFunction = ({ params }) => {
  return subscribe(params.email!);
};

export function useSubscribeLoaderData() {
  return useLoaderData<Awaited<ReturnType<typeof subscribe>>>();
}
